import React, { Component } from 'react';
import {c_light, c_background, c_gradient_reds} from '../a-Graphic/Colors';

import getMyMap, {createCommuneBordersLayer, createNamesLayer, createCommuneLayerFlows,
  createCommuneFlowsLayer, getLegendMode} from '../b-LeafletMap/leaflet_map';

import LegendCommune from '../b-LeafletMap/Legend/LegendCommune';
import LegendClusterArea from '../b-LeafletMap/Legend/LegendClusterArea';
import LegendValuesFlows from '../b-LeafletMap/Legend/LegendValuesFlows';
import LegendValues from '../b-LeafletMap/Legend/LegendValues';

const L = window.L;

var limit_flows_nb = 1000;

class FlowsOD_Outside extends React.Component {
  constructor(props) {
   super(props);

   this.state = {
     unit: "distance",
     label: "km",
     legend: "de la distance totale"
   };

    this.mode = "ckmeans"
    this.colors = c_gradient_reds
 }

 setUnit = (unit, label, legend) => {
     this.setState({
       unit: unit,
       label: label,
       legend: legend
     })
 }

  get_flows(){
    let flows_od = this.props.territory.all_travels.flows_od_outside[this.state.unit];
    let geo_code_dict = this.props.territory.geo_code_dict;

    let total_flows = flows_od.map((f)=>f[2]).reduce((a,b)=>a+b,0)

    flows_od = flows_od.sort((a,b)=> b[2] - a[2])
    flows_od = flows_od.slice(0, limit_flows_nb)

    let flows_coords = flows_od.map((f)=> [geo_code_dict[f[0]]["center"], geo_code_dict[f[1]]["center"]])
    let flows_masses = flows_od.map((f)=> f[2])
    let flows_labels = flows_od.map((f)=> geo_code_dict[f[0]]["name"] + " ↔ " + geo_code_dict[f[1]]["name"]  + " : " + f[2].toLocaleString("fr-FR") + " " + this.state.label) // + " (" + Math.round(f[2]/total_flows*1000)/10 + "%)")
    return {flows_coords, flows_masses, flows_labels}
  }

  componentDidMount() {
    /* COMMUNES */
    var communes = this.props.territory.communes;
    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    var {flows_coords, flows_masses, flows_labels} = this.get_flows()

    // --- init map
    var mymap = this.mymap = getMyMap(this.props.id, true, 0.3);

    var communes_layer = this.communes_layer = createCommuneBordersLayer(mymap, communes)
    this.flows_layer = createCommuneFlowsLayer(mymap, flows_coords, flows_masses, flows_labels, this.mode, this.colors);

    // --- center the map
    mymap.fitBounds(communes_layer.getBounds());
  }

  componentDidUpdate(){
    var {flows_coords, flows_masses, flows_labels} = this.get_flows()
    this.mymap.removeLayer(this.flows_layer)
    this.flows_layer = createCommuneFlowsLayer(this.mymap, flows_coords, flows_masses, flows_labels, this.mode, this.colors);
  }


  render() {
    var flows_od = this.props.territory.all_travels.flows_od_outside[this.state.unit];
    var total_mass = flows_od.map((c) => c[2]).reduce((a,b)=> a+b,0)

    flows_od = flows_od.sort((a,b)=> b[2] - a[2])
    flows_od = flows_od.slice(0, limit_flows_nb)
    var flows_masses = flows_od.map((c) => c[2])

    var displayed_total_mass = flows_masses.reduce((a,b)=> a+b,0)

    var [intervals, colors] = getLegendMode(this.mode, flows_masses, this.colors);
    return(
      <div className="row content mt-4 mb-5">
        <div className="col-12">

          <div className="row">
            <div className="col-12">
              <h4 className="mb-3">principaux flux vers l'extérieur</h4>
            </div>
          </div>

          <div className="row mt-1 mb-2">
            <div className="col-auto pr-1">
              <p onClick={this.setUnit.bind(this, "distance", "km", "de la distance totale")}
                 className={this.state.unit == "distance" ? "button p-1 pl-2 pr-2 active" : "button p-1 pl-2 pr-2"}>Distance parcourue</p>
            </div>
            <div className="col-auto pr-1">
              <p onClick={this.setUnit.bind(this, "number", "déplacements", "du nombre total de déplacements")}
                 className={this.state.unit == "number" ? "button p-1 pl-2 pr-2 active" : "button p-1 pl-2 pr-2"}>Nombre de déplacements</p>
            </div>
            <div className="col-auto pr-1">
              <p onClick={this.setUnit.bind(this, "ghg_emissions", "tCO2eq", "des émissions totales")}
                 className={this.state.unit == "ghg_emissions" ? "button p-1 pl-2 pr-2 active" : "button p-1 pl-2 pr-2"}>Emissions de GES</p>
            </div>
          </div>

          <div className="row align-items-end">
            <div className="col-9">
              <div style={{height: "600px"}} id={this.props.id}></div>
            </div>
            <div className="col-3">
            <p className="pl-3 mb-5"></p>
                 <LegendValuesFlows intervals={intervals} colors={colors} label={"("+this.state.label+"/jour)"}/>
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default FlowsOD_Outside;
